import React from 'react'
import getUrl from 'front-end-core/core/url'

const NavLink = ({ title, target, params, className, linkClassName, hideNavigation, aol, flavour, url, external = false }) => (
  <li
    data-event-category='Mobile Menu'
    data-event-action='Select'
    data-event-label={title}
    className={className}
  >
    <a
      href={url || getUrl(target, { aol, flavour, ...params })}
      onClick={hideNavigation}
      tabIndex='-1'
      className={linkClassName}
      target={external ? '_blank' : '_self'}
      rel='noopener noreferrer'
    >
      {title}
    </a>
  </li>
)

export default NavLink
